module.exports = require("@formatjs/intl-pluralrules/locale-data/id");